<template>
    <div data-test-id="l-reviews-edit-questions-form">
        <l-translation-modal
            v-show="showTranslationModal"
            :existing-translations="translations"
            :input-type="inputType"
            @cancel="showTranslationModal = false"
            @confirm="updateTranslations"
        />
        <div>
            <h4 class="reviewSetupHeading color-dark">
                <strong>{{ $t(`reviews.admin.labelQuestionnaire`) }}</strong>
                <span class="color-grey l-default-margin-s">
                    <i class="fal fa-hand-pointer"></i>
                    <span class="l-default-margin-s">{{ $t(`reviews.admin.labelDragNDrop`) }}</span>
                </span>
                <span
                    class="color-primary pull-right clickable"
                    tabindex="0"
                    @click="questionToggleExpansion(0, true)"
                    @keyup.enter="questionToggleExpansion(0, true)"
                >
                    <i class="fal fa-cog r-default-margin-s"></i>
                    <span>{{ $t(`reviews.admin.labelShowQuestionSettingsAll`) }}</span>
                </span>
            </h4>

            <!-- Start questions top -->

            <draggable
                v-model="reviewCycle.questions.selected"
                v-bind="{
                    animation: 200,
                    group: 'description',
                    disabled: !isTemplate && reviewCycle.status.globalStatus != 'draft',
                    ghostClass: 'ghost',
                }"
                filter=".form-group"
                :prevent-on-filter="false"
                tag=""
                class="dropzone"
                style="padding: 0;"
            >
                <transition-group tag="ul" style="margin: 0; padding: 0;">
                    <li
                        v-for="(question, index) in reviewCycle.questions.selected"
                        :key="question._id || question.tempId || question.name"
                    >
                        <!--  Section -->

                        <div v-show="question.type === 'reviewSection'" class="card card-light">
                            <div
                                class="card-header"
                                :class="
                                    question.expanded
                                        ? 'card-header-semi-rounded'
                                        : 'card-header-rounded'
                                "
                            >
                                <div class="input-group">
                                    <span
                                        v-b-popover.hover.top="
                                            $t(`reviews.admin.labelShowQuestionSettings`)
                                        "
                                        class="input-group-addon clickable"
                                        tabindex="0"
                                        @click="questionToggleExpansion(index)"
                                        @keyup.enter="questionToggleExpansion(index)"
                                    >
                                        <i
                                            class="far fa-cog color-primary"
                                            style="margin-left: -10px"
                                        ></i>
                                    </span>
                                    <div
                                        style="margin-top: -5px; margin-bottom: -10px; margin-left: -5px"
                                    >
                                        <div class="tw-relative">
                                            <l-input-text
                                                v-model="question.name"
                                                style="background-color: #ffffff"
                                                input-class="tw-mb-0"
                                                :label="``"
                                                :placeholder="$t(`reviews.admin.labelSection`)"
                                                :disabled="
                                                    reviewCycle.questionsLocked ||
                                                        question.type === 'team' ||
                                                        question.type === 'localTeam'
                                                "
                                                optional
                                                hide-help-block
                                                @input="
                                                    () => {
                                                        updateSkillTranslation(question, 'name');
                                                    }
                                                "
                                            />
                                            <span
                                                v-if="
                                                    !(
                                                        reviewCycle.questionsLocked ||
                                                        question.type === 'team' ||
                                                        question.type === 'localTeam'
                                                    )
                                                "
                                                v-b-popover.hover.top="
                                                    $t(`skills.translate.iconPopover`)
                                                "
                                                class="tw-absolute tw-cursor-pointer tw-text-lg tw-text-gray-400 hover:tw-text-gray-900"
                                                style="top: 7px; right: 14px; z-index: 3;"
                                                tabindex="0"
                                                @click="openTranslationModal(question, 'name')"
                                                @keyup.enter="
                                                    openTranslationModal(question, 'name')
                                                "
                                            >
                                                <i class="fal fa-language"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-show="question.expanded" class="card-block">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div style="margin-top: 0px; padding-right: 16px;">
                                            <div class="tw-relative">
                                                <l-input-text
                                                    v-model="question.description"
                                                    type="textarea"
                                                    :disabled="
                                                        reviewCycle.questionsLocked ||
                                                            question.type === 'team' ||
                                                            question.type == 'localTeam'
                                                    "
                                                    :label="``"
                                                    :placeholder="
                                                        $t(
                                                            `reviews.admin.labelInstructionPlaceholder`,
                                                        )
                                                    "
                                                    optional
                                                    hide-help-block
                                                    @input="
                                                        () => {
                                                            updateSkillTranslation(
                                                                question,
                                                                'description',
                                                            );
                                                        }
                                                    "
                                                />
                                                <span
                                                    v-if="
                                                        !(
                                                            reviewCycle.questionsLocked ||
                                                            question.type === 'team' ||
                                                            question.type === 'localTeam'
                                                        )
                                                    "
                                                    v-b-popover.hover.top="
                                                        $t(`skills.translate.iconPopover`)
                                                    "
                                                    class="tw-absolute tw-cursor-pointer tw-text-lg tw-text-gray-400 hover:tw-text-gray-900"
                                                    style="bottom:1px; right: 14px;"
                                                    tabindex="0"
                                                    @click="
                                                        openTranslationModal(
                                                            question,
                                                            'description',
                                                            'textarea',
                                                        )
                                                    "
                                                    @keyup.enter="
                                                        openTranslationModal(
                                                            question,
                                                            'description',
                                                            'textarea',
                                                        )
                                                    "
                                                >
                                                    <i class="fal fa-language"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <span
                                            v-b-popover.hover.top="`Remove section`"
                                            style="
                            display: inline-block;
                            position: absolute;
                            right: 8px;
                            bottom: 9px;"
                                            class="pull-right clickable"
                                            tabindex="0"
                                            @click="removeQuestion(index)"
                                            @keyup.enter="removeQuestion(index)"
                                        >
                                            <i class="fal fa-trash color-primary"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Custom Question -->

                        <div
                            v-show="
                                [
                                    'reviewSection',
                                    'reviewCompanySkillPlaceholder',
                                    'reviewTeamSkillPlaceholder',
                                    'reviewGoalPlaceholder',
                                ].indexOf(question.type) === -1
                            "
                            class="card card-light"
                        >
                            <div
                                class="card-header"
                                :class="
                                    question.expanded
                                        ? 'card-header-semi-rounded'
                                        : 'card-header-rounded'
                                "
                            >
                                <div class="input-group">
                                    <span
                                        v-b-popover.hover.top="
                                            $t(`reviews.admin.labelShowQuestionSettings`)
                                        "
                                        class="input-group-addon clickable"
                                        tabindex="0"
                                        @click="questionToggleExpansion(index)"
                                        @keyup.enter="questionToggleExpansion(index)"
                                    >
                                        <i
                                            class="far fa-cog color-primary"
                                            style="margin-left: -10px"
                                        ></i>
                                    </span>
                                    <div
                                        style="margin-top: -5px; margin-bottom: -10px; margin-left: -5px"
                                    >
                                        <div class="tw-relative">
                                            <l-input-text
                                                v-model="question.name"
                                                v-b-popover.hover.top="
                                                    $t(`reviews.admin.labelQuestionChange`)
                                                "
                                                style="background-color: #ffffff"
                                                input-class="tw-mb-0"
                                                :disabled="
                                                    reviewCycle.questionsLocked ||
                                                        question.type === 'team' ||
                                                        question.type === 'localTeam'
                                                "
                                                :placeholder="$t(`reviews.admin.labelQuestion`)"
                                                optional
                                                hide-help-block
                                            />
                                            <span
                                                v-if="
                                                    !(
                                                        reviewCycle.questionsLocked ||
                                                        question.type === 'team' ||
                                                        question.type === 'localTeam'
                                                    )
                                                "
                                                v-b-popover.hover.top="
                                                    $t(`skills.translate.iconPopover`)
                                                "
                                                class="tw-absolute tw-cursor-pointer tw-text-lg tw-text-gray-400 hover:tw-text-gray-900"
                                                style="top: 7px; right: 14px; z-index: 3;"
                                                tabindex="0"
                                                @click="openTranslationModal(question, 'name')"
                                                @keyup.enter="
                                                    openTranslationModal(question, 'name')
                                                "
                                            >
                                                <i class="fal fa-language"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-show="question.expanded" class="card-block">
                                <div
                                    v-show="
                                        question.showDescription ||
                                            (question.description && question.description !== '')
                                    "
                                    class="row"
                                >
                                    <div class="col-md-12">
                                        <div class="tw-relative">
                                            <l-input-text
                                                v-model="question.description"
                                                style="margin-top: 0px"
                                                :disabled="
                                                    reviewCycle.questionsLocked ||
                                                        question.type === 'team' ||
                                                        question.type === 'localTeam'
                                                "
                                                :placeholder="
                                                    $t(`reviews.admin.labelInstructionPlaceholder`)
                                                "
                                                optional
                                            />
                                            <span
                                                v-if="
                                                    !(
                                                        reviewCycle.questionsLocked ||
                                                        question.type === 'team' ||
                                                        question.type === 'localTeam'
                                                    )
                                                "
                                                v-b-popover.hover.top="
                                                    $t(`skills.translate.iconPopover`)
                                                "
                                                class="tw-absolute tw-cursor-pointer tw-text-lg tw-text-gray-400 hover:tw-text-gray-900"
                                                style="top: 7px; right: 14px; z-index: 3;"
                                                tabindex="0"
                                                @click="
                                                    openTranslationModal(question, 'description')
                                                "
                                                @keyup.enter="
                                                    openTranslationModal(question, 'description')
                                                "
                                            >
                                                <i class="fal fa-language"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div v-show="question.type" class="row">
                                    <div class="col-md-6" style="margin-top: 10px">
                                        <button
                                            v-show="reviewCycle.selfEvaluationsEnabled"
                                            v-b-popover.hover.top="
                                                $t(`reviews.admin.helpRoleReviewee`)
                                            "
                                            class="btn-invisible color-primary"
                                            @click="questionToggleRole(question, 'roleReviewee')"
                                        >
                                            <i
                                                class="fal"
                                                :class="{
                                                    'fa-check-circle color-primary':
                                                        question.roleReviewee,
                                                    'fa-circle': !question.roleReviewee,
                                                }"
                                            >
                                            </i>
                                            <span class="l-default-margin-s">{{
                                                $t(`reviews.admin.labelRoleReviewee`)
                                            }}</span>
                                        </button>
                                        <button
                                            v-show="reviewCycle.managerReviewsEnabled"
                                            v-b-popover.hover.top="
                                                $t(`reviews.admin.helpRoleManager`)
                                            "
                                            class="btn-invisible color-primary"
                                            @click="questionToggleRole(question, 'roleManager')"
                                        >
                                            <i
                                                class="fal"
                                                :class="{
                                                    'fa-check-circle color-primary':
                                                        question.roleManager,
                                                    'fa-circle': !question.roleManager,
                                                }"
                                            >
                                            </i>
                                            <span class="l-default-margin-s">{{
                                                $t(`reviews.admin.labelRoleManager`)
                                            }}</span>
                                        </button>
                                        <button
                                            v-show="reviewCycle.peerReviewsEnabled"
                                            v-b-popover.hover.top="$t(`reviews.admin.helpRolePeer`)"
                                            class="btn-invisible color-primary"
                                            @click="questionToggleRole(question, 'rolePeer')"
                                        >
                                            <i
                                                class="fal"
                                                :class="{
                                                    'fa-check-circle color-primary':
                                                        question.rolePeer,
                                                    'fa-circle': !question.rolePeer,
                                                }"
                                            >
                                            </i>
                                            <span class="l-default-margin-s">{{
                                                $t(`reviews.admin.labelRolePeer`)
                                            }}</span>
                                        </button>
                                        <button
                                            v-show="reviewCycle.directReportReviewsEnabled"
                                            v-b-popover.hover.top="
                                                $t(`reviews.admin.helpRoleDirectReport`)
                                            "
                                            class="btn-invisible color-primary"
                                            @click="
                                                questionToggleRole(question, 'roleDirectReport')
                                            "
                                        >
                                            <i
                                                class="fal"
                                                :class="{
                                                    'fa-check-circle color-primary':
                                                        question.roleDirectReport,
                                                    'fa-circle': !question.roleDirectReport,
                                                }"
                                            >
                                            </i>
                                            <span class="l-default-margin-s">{{
                                                $t(`reviews.admin.labelRoleDirectReport`)
                                            }}</span>
                                        </button>
                                    </div>

                                    <div
                                        :class="{
                                            'col-md-2': reviewCycle.questions.customScoresEnabled,
                                            'col-md-3': !reviewCycle.questions.customScoresEnabled,
                                        }"
                                    >
                                        <div style="margin-top: 0px">
                                            <l-select
                                                v-model="question.ratingRequirement"
                                                :options="optionsRatingRequirement"
                                                :disabled="
                                                    (reviewCycle.isCreatedFromTemplate &&
                                                        reviewCycle.createdAsRole != 'admin') ||
                                                        question.answerType == 'multipleChoice'
                                                "
                                            />
                                        </div>
                                    </div>

                                    <div
                                        v-show="
                                            reviewCycle.questions.customScoresEnabled &&
                                                question.ratingRequirement != 'hidden'
                                        "
                                        class="col-md-1"
                                    >
                                        <div style="margin-top: 0px">
                                            <l-input-text
                                                v-model="question.weight"
                                                type="number"
                                                :placeholder="$t(`reviews.admin.labelWeight`)"
                                                :disabled="reviewCycle.questionsLocked"
                                            />
                                        </div>
                                    </div>

                                    <div class="col-md-3">
                                        <div style="margin-top: 0px">
                                            <l-select
                                                v-model="question.commentRequirement"
                                                :options="optionsCommentRequirement"
                                                :disabled="
                                                    (reviewCycle.isCreatedFromTemplate &&
                                                        reviewCycle.createdAsRole != 'admin') ||
                                                        question.answerType == 'multipleChoice'
                                                "
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-10">
                                        <div class="hr-small"></div>
                                        <button
                                            v-b-popover.hover.top="
                                                $t(`reviews.admin.helpPrivateQuestion`)
                                            "
                                            class="btn-invisible color-primary"
                                            @click="questionTogglePrivate(index)"
                                        >
                                            <i
                                                class="fal"
                                                :class="{
                                                    'fa-check-circle color-primary':
                                                        question.private,
                                                    'fa-circle': !question.private,
                                                }"
                                            >
                                            </i>
                                            <span class="l-default-margin-s">{{
                                                $t(`reviews.admin.labelPrivateQuestion`)
                                            }}</span>
                                        </button>

                                        <button
                                            v-show="
                                                question.type != 'team' &&
                                                    question.type != 'localTeam'
                                            "
                                            class="btn-invisible color-primary"
                                            :disabled="reviewCycle.questionsLocked"
                                            @click="questionToggleMultipleChoice(index)"
                                        >
                                            <i
                                                class="fal"
                                                :class="{
                                                    'fa-check-circle color-primary':
                                                        question.answerType == 'multipleChoice',
                                                    'fa-circle':
                                                        question.answerType != 'multipleChoice',
                                                }"
                                            >
                                            </i>
                                            <span class="l-default-margin-s">{{
                                                $t(`reviews.admin.labelMultipleChoice`)
                                            }}</span>
                                        </button>

                                        <button
                                            v-show="question.ratingRequirement != 'hidden'"
                                            v-b-popover.hover.top="
                                                $t(`reviews.admin.helpCustomScale`)
                                            "
                                            class="btn-invisible color-primary"
                                            :disabled="reviewCycle.questionsLocked"
                                            @click="toggleCustomScale(question)"
                                        >
                                            <i
                                                class="fal"
                                                :class="{
                                                    'fa-check-circle color-primary':
                                                        question.scale && question.scale.enabled,
                                                    'fa-circle': !(
                                                        question.scale && question.scale.enabled
                                                    ),
                                                }"
                                            >
                                            </i>
                                            <span class="l-default-margin-s">{{
                                                $t(`reviews.admin.labelEnableCustomScale`)
                                            }}</span>
                                        </button>

                                        <button
                                            v-show="question.type != 'team'"
                                            class="btn-invisible color-primary"
                                            :disabled="
                                                reviewCycle.questionsLocked ||
                                                    question.type == 'team' ||
                                                    question.type == 'localTeam'
                                            "
                                            @click="
                                                $set(
                                                    question,
                                                    'showDescription',
                                                    question.showDescription ? false : true,
                                                )
                                            "
                                        >
                                            <i class="fal fa-file"> </i>
                                            <span class="l-default-margin-s">{{
                                                $t(`reviews.admin.labelAddInstructions`)
                                            }}</span>
                                        </button>
                                    </div>

                                    <div
                                        v-show="!reviewCycle.questionSettingsLocked"
                                        class="col-md-2 color-primary"
                                    >
                                        <div class="hr-small"></div>

                                        <span
                                            v-b-popover.hover.top="
                                                $t(`reviews.admin.helpRemoveQuestion`)
                                            "
                                            class="pull-right clickable"
                                            @click="removeQuestion(index)"
                                            @keyup.enter="removeQuestion(index)"
                                        >
                                            <i class="fal fa-trash"></i>
                                        </span>
                                    </div>
                                </div>

                                <!-- multiple choice -->

                                <div v-show="question.answerType == 'multipleChoice'">
                                    <div class="hr-small"></div>

                                    <div
                                        v-for="(option, mcIndex) in question.multipleChoiceOptions"
                                        :key="`${index}-mc-${mcIndex}`"
                                    >
                                        <div class="row">
                                            <div class="col-md-11 tw-relative">
                                                <l-input-text
                                                    v-model="option.title"
                                                    style="margin-top: 10px"
                                                    :placeholder="
                                                        $t(`reviews.admin.placeholderOption`)
                                                    "
                                                    :disabled="
                                                        reviewCycle.questionsLocked ||
                                                            question.type == 'team' ||
                                                            question.type == 'localTeam'
                                                    "
                                                    @input="
                                                        () => {
                                                            updateSkillTranslation(
                                                                question,
                                                                `multipleChoiceOptions.${mcIndex}.title`,
                                                            );
                                                        }
                                                    "
                                                />
                                                <span
                                                    v-b-popover.hover.top="
                                                        $t(`skills.translate.iconPopover`)
                                                    "
                                                    class="tw-absolute tw-cursor-pointer tw-text-lg tw-text-gray-400 hover:tw-text-gray-900"
                                                    style="top: 15px; right: 35px; z-index: 3;"
                                                    tabindex="0"
                                                    @click="
                                                        openTranslationModal(
                                                            question,
                                                            `multipleChoiceOptions.${mcIndex}.title`,
                                                        )
                                                    "
                                                    @keyup.enter="
                                                        openTranslationModal(
                                                            question,
                                                            `multipleChoiceOptions.${mcIndex}.title`,
                                                        )
                                                    "
                                                >
                                                    <i class="fal fa-language"></i>
                                                </span>
                                            </div>
                                            <div class="col-md-1" style="padding-top: 20px">
                                                <i
                                                    v-show="
                                                        question.multipleChoiceOptions.length > 1
                                                    "
                                                    class="fal fa-trash color-primary pull-right clickable"
                                                    tabindex="0"
                                                    @click="
                                                        removeMultipleChoiceOption(index, mcIndex)
                                                    "
                                                    @keyup.enter="
                                                        removeMultipleChoiceOption(index, mcIndex)
                                                    "
                                                ></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-3">
                                            <button
                                                class="btn btn-primary btn-block btn-framed-primary"
                                                @click="addMultipleChoiceOption(index)"
                                            >
                                                {{ $t(`reviews.admin.labelNewMCOption`) }}
                                            </button>
                                        </div>

                                        <div class="col-md-6 col-md-offset-3">
                                            <button
                                                class="btn-invisible color-primary pull-right"
                                                style="margin-top: 15px"
                                                :disabled="
                                                    reviewCycle.questionsLocked ||
                                                        question.type == 'team' ||
                                                        question.type == 'localTeam'
                                                "
                                                @click="questionToggleAllowMultipleAnswers(index)"
                                            >
                                                <i
                                                    class="fal color-primary"
                                                    :class="{
                                                        'fa-check-circle':
                                                            question.allowMultipleAnswers,
                                                        'fa-circle': !question.allowMultipleAnswers,
                                                    }"
                                                >
                                                </i>
                                                <span class="l-default-margin-s">{{
                                                    $t(`reviews.admin.labelAllowMultipleAnswers`)
                                                }}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- custom scale -->

                                <div
                                    v-if="
                                        question.ratingRequirement != 'hidden' &&
                                            question.scale &&
                                            question.scale.enabled
                                    "
                                >
                                    <div class="hr-small"></div>
                                    <l-space :size="2" />

                                    <div class="row">
                                        <div class="col-md-2">
                                            <l-select
                                                :value="question.scale.type"
                                                :label="$t(`reviews.admin.labelScaleType`)"
                                                :options="optionsScaleType"
                                                :disabled="reviewCycle.questionsLocked"
                                                @input="
                                                    val => {
                                                        question.scale.type = val;
                                                        updateScale(question, val);
                                                    }
                                                "
                                            />
                                        </div>
                                        <div class="col-md-10">
                                            <div
                                                v-for="item in [
                                                    '1st',
                                                    '2nd',
                                                    '3rd',
                                                    '4th',
                                                    '5th',
                                                    '6th',
                                                    '7th',
                                                ]"
                                                :key="item"
                                            >
                                                <l-input-text
                                                    v-if="
                                                        question.scale.type >= item.charAt(0) &&
                                                            question.scale.type != '100'
                                                    "
                                                    v-model="
                                                        question.scale[`r${item.charAt(0)}`].label
                                                    "
                                                    :label="$t(`reviews.admin.label${item}`)"
                                                />
                                            </div>

                                            <!-- start continues scale -->
                                            <template v-if="question.scale.type === '100'">
                                                <l-input-text
                                                    v-model="question.scale.r1.label"
                                                    :label="$t(`reviews.admin.labelLowerEnd`)"
                                                    :disabled="reviewCycle.questionsLocked"
                                                />
                                                <l-input-text
                                                    v-model="question.scale.r5.label"
                                                    :label="$t(`reviews.admin.labelUpperEnd`)"
                                                    :disabled="reviewCycle.questionsLocked"
                                                />
                                            </template>
                                            <!-- end continues scale -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Company Skills -->

                        <div
                            v-show="question.type == 'reviewCompanySkillPlaceholder'"
                            class="card card-light"
                        >
                            <div
                                class="card-header"
                                :class="{
                                    'card-header-semi-rounded':
                                        reviewCycle.questions.companySkills.enabled,
                                    'card-header-rounded': !reviewCycle.questions.companySkills
                                        .enabled,
                                }"
                            >
                                <div class="row">
                                    <div
                                        v-show="!reviewCycle.questionsLocked"
                                        class="col-md-12 clickable"
                                        tabindex="0"
                                        @click="
                                            toggleCompanySkills();
                                            indexQuestions(
                                                false,
                                                reviewCycle.questions.teamSkills.manual,
                                            );
                                        "
                                        @keyup.enter="
                                            toggleCompanySkills();
                                            indexQuestions(
                                                false,
                                                reviewCycle.questions.teamSkills.manual,
                                            );
                                        "
                                    >
                                        <span>
                                            <i
                                                class="fal color-primary"
                                                :class="{
                                                    'fa-check-circle':
                                                        reviewCycle.questions.companySkills.enabled,
                                                    'fa-circle': !reviewCycle.questions
                                                        .companySkills.enabled,
                                                }"
                                            >
                                            </i>
                                            <span
                                                v-show="reviewCycle.questions.companySkills.enabled"
                                                class="l-default-margin-s"
                                                ><l-text
                                                    :text="$t(`reviews.admin.includeCompanySkills`)"
                                            /></span>
                                            <span
                                                v-show="
                                                    !reviewCycle.questions.companySkills.enabled
                                                "
                                                class="l-default-margin-s"
                                                ><l-text
                                                    :text="
                                                        $t(
                                                            `reviews.admin.includeCompanySkillsSelect`,
                                                        )
                                                    "
                                            /></span>
                                        </span>
                                    </div>
                                    <div v-show="reviewCycle.questionsLocked" class="col-md-12">
                                        <span>
                                            <i
                                                class="fal color-primary"
                                                :class="{
                                                    'fa-check-circle':
                                                        reviewCycle.questions.companySkills.enabled,
                                                    'fa-circle': !reviewCycle.questions
                                                        .companySkills.enabled,
                                                }"
                                            >
                                            </i
                                            ><span
                                                v-show="reviewCycle.questions.companySkills.enabled"
                                                class="l-default-margin-s"
                                                ><l-text
                                                    :text="$t(`reviews.admin.includeCompanySkills`)"
                                            /></span>
                                            <span
                                                v-show="
                                                    !reviewCycle.questions.companySkills.enabled
                                                "
                                                class="l-default-margin-s"
                                                ><l-text
                                                    :text="
                                                        $t(
                                                            `reviews.admin.includeCompanySkillsSelect`,
                                                        )
                                                    "
                                                />
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-show="reviewCycle.questions.companySkills.enabled"
                                class="card-block"
                            >
                                <div class="row">
                                    <div class="col-md-6" style="margin-top: 10px">
                                        <button
                                            v-show="reviewCycle.selfEvaluationsEnabled"
                                            v-b-popover.hover.top="
                                                $t(`reviews.admin.helpRoleReviewee`)
                                            "
                                            class="btn-invisible color-primary"
                                            @click="
                                                questionToggleRole('companySkills', 'roleReviewee')
                                            "
                                        >
                                            <i
                                                class="fal color-primary"
                                                :class="{
                                                    'fa-check-circle':
                                                        reviewCycle.questions.companySkills
                                                            .roleReviewee,
                                                    'fa-circle': !reviewCycle.questions
                                                        .companySkills.roleReviewee,
                                                }"
                                            >
                                            </i>
                                            <span class="l-default-margin-s">{{
                                                $t(`reviews.admin.labelRoleReviewee`)
                                            }}</span>
                                        </button>
                                        <button
                                            v-show="reviewCycle.managerReviewsEnabled"
                                            v-b-popover.hover.top="
                                                $t(`reviews.admin.helpRoleManager`)
                                            "
                                            class="btn-invisible color-primary"
                                            @click="
                                                questionToggleRole('companySkills', 'roleManager')
                                            "
                                        >
                                            <i
                                                class="fal color-primary"
                                                :class="{
                                                    'fa-check-circle':
                                                        reviewCycle.questions.companySkills
                                                            .roleManager,
                                                    'fa-circle': !reviewCycle.questions
                                                        .companySkills.roleManager,
                                                }"
                                            >
                                            </i>
                                            <span class="l-default-margin-s">{{
                                                $t(`reviews.admin.labelRoleManager`)
                                            }}</span>
                                        </button>
                                        <button
                                            v-show="reviewCycle.peerReviewsEnabled"
                                            v-b-popover.hover.top="$t(`reviews.admin.helpRolePeer`)"
                                            class="btn-invisible color-primary"
                                            @click="questionToggleRole('companySkills', 'rolePeer')"
                                        >
                                            <i
                                                class="fal color-primary"
                                                :class="{
                                                    'fa-check-circle':
                                                        reviewCycle.questions.companySkills
                                                            .rolePeer,
                                                    'fa-circle': !reviewCycle.questions
                                                        .companySkills.rolePeer,
                                                }"
                                            >
                                            </i>
                                            <span class="l-default-margin-s">{{
                                                $t(`reviews.admin.labelRolePeer`)
                                            }}</span>
                                        </button>
                                        <button
                                            v-show="reviewCycle.directReportReviewsEnabled"
                                            v-b-popover.hover.top="
                                                $t(`reviews.admin.helpRoleDirectReport`)
                                            "
                                            class="btn-invisible color-primary"
                                            @click="
                                                questionToggleRole(
                                                    'companySkills',
                                                    'roleDirectReport',
                                                )
                                            "
                                        >
                                            <i
                                                class="fal color-primary"
                                                :class="{
                                                    'fa-check-circle':
                                                        reviewCycle.questions.companySkills
                                                            .roleDirectReport,
                                                    'fa-circle': !reviewCycle.questions
                                                        .companySkills.roleDirectReport,
                                                }"
                                            >
                                            </i>
                                            <span class="l-default-margin-s">{{
                                                $t(`reviews.admin.labelRoleDirectReport`)
                                            }}</span>
                                        </button>
                                    </div>

                                    <div
                                        :class="{
                                            'col-md-2': reviewCycle.questions.customScoresEnabled,
                                            'col-md-3': !reviewCycle.questions.customScoresEnabled,
                                        }"
                                    >
                                        <div style="margin-top: 0px">
                                            <l-select
                                                v-model="
                                                    reviewCycle.questions.companySkills
                                                        .ratingRequirement
                                                "
                                                :options="optionsRatingRequirement"
                                                :disabled="
                                                    reviewCycle.isCreatedFromTemplate &&
                                                        reviewCycle.createdAsRole != 'admin'
                                                "
                                            />
                                        </div>
                                    </div>

                                    <div
                                        v-show="
                                            reviewCycle.questions.customScoresEnabled &&
                                                reviewCycle.questions.companySkills
                                                    .ratingRequirement != 'hidden'
                                        "
                                        class="col-md-1"
                                    >
                                        <div style="margin-top: 0px">
                                            <l-input-text
                                                v-model="reviewCycle.questions.companySkills.weight"
                                                :disabled="reviewCycle.questionsLocked"
                                                :placeholder="$t(`reviews.admin.labelWeight`)"
                                            />
                                        </div>
                                    </div>

                                    <div class="col-md-3">
                                        <div style="margin-top: 0px">
                                            <l-select
                                                v-model="
                                                    reviewCycle.questions.companySkills
                                                        .commentRequirement
                                                "
                                                :options="optionsCommentRequirement"
                                                :disabled="
                                                    reviewCycle.isCreatedFromTemplate &&
                                                        reviewCycle.createdAsRole != 'admin'
                                                "
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="color-grey">
                                    <div class="hr-small"></div>
                                    <span v-html="$t(`reviews.admin.labelHelpSkills`)"></span>
                                    <span
                                        v-show="!reviewCycle.questionsLocked"
                                        class="pull-right clickable"
                                        @click="
                                            indexQuestions(
                                                true,
                                                reviewCycle.questions.teamSkills.manual,
                                            )
                                        "
                                        @keyup.enter="
                                            indexQuestions(
                                                true,
                                                reviewCycle.questions.teamSkills.manual,
                                            )
                                        "
                                    >
                                        <i class="fal fa-cog"></i>
                                        <span class="l-default-margin-s">{{
                                            $t(`reviews.admin.btnPickManually`)
                                        }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- Team Skills -->

                        <div
                            v-show="question.type == 'reviewTeamSkillPlaceholder'"
                            class="card card-light"
                        >
                            <div
                                class="card-header"
                                :class="{
                                    'card-header-semi-rounded':
                                        reviewCycle.questions.teamSkills.enabled,
                                    'card-header-rounded': !reviewCycle.questions.teamSkills
                                        .enabled,
                                }"
                            >
                                <div class="row">
                                    <div
                                        v-show="!reviewCycle.questionsLocked"
                                        class="col-md-12 clickable"
                                        tabindex="0"
                                        @click="
                                            toggleTeamSkills();
                                            indexQuestions(
                                                reviewCycle.questions.companySkills.manual,
                                                false,
                                            );
                                        "
                                        @keyup.enter="
                                            toggleTeamSkills();
                                            indexQuestions(
                                                reviewCycle.questions.companySkills.manual,
                                                false,
                                            );
                                        "
                                    >
                                        <span>
                                            <i
                                                class="fal color-primary"
                                                :class="{
                                                    'fa-check-circle':
                                                        reviewCycle.questions.teamSkills.enabled,
                                                    'fa-circle': !reviewCycle.questions.teamSkills
                                                        .enabled,
                                                }"
                                            >
                                            </i>
                                            <span
                                                v-show="reviewCycle.questions.teamSkills.enabled"
                                                class="l-default-margin-s"
                                                ><l-text
                                                    :text="$t(`reviews.admin.includeTeamSkills`)"
                                            /></span>
                                            <span
                                                v-show="!reviewCycle.questions.teamSkills.enabled"
                                                class="l-default-margin-s"
                                                ><l-text
                                                    :text="
                                                        $t(`reviews.admin.includeTeamSkillsSelect`)
                                                    "
                                                />
                                            </span>
                                        </span>
                                    </div>
                                    <div v-show="reviewCycle.questionsLocked" class="col-md-12">
                                        <span>
                                            <i
                                                class="fal color-primary"
                                                :class="{
                                                    'fa-check-circle':
                                                        reviewCycle.questions.teamSkills.enabled,
                                                    'fa-circle': !reviewCycle.questions.teamSkills
                                                        .enabled,
                                                }"
                                            >
                                            </i>
                                            <span
                                                v-show="reviewCycle.questions.teamSkills.enabled"
                                                class="l-default-margin-s"
                                                ><l-text
                                                    :text="$t(`reviews.admin.includeTeamSkills`)"
                                            /></span>
                                            <span
                                                v-show="!reviewCycle.questions.teamSkills.enabled"
                                                class="l-default-margin-s"
                                                ><l-text
                                                    :text="
                                                        $t(`reviews.admin.includeTeamSkillsSelect`)
                                                    "
                                            /></span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-show="reviewCycle.questions.teamSkills.enabled"
                                class="card-block"
                            >
                                <div class="row">
                                    <div class="col-md-6" style="margin-top: 10px">
                                        <button
                                            v-show="reviewCycle.selfEvaluationsEnabled"
                                            v-b-popover.hover.top="
                                                $t(`reviews.admin.helpRoleReviewee`)
                                            "
                                            class="btn-invisible color-primary"
                                            @click="
                                                questionToggleRole('teamSkills', 'roleReviewee')
                                            "
                                        >
                                            <i
                                                class="fal color-primary"
                                                :class="{
                                                    'fa-check-circle':
                                                        reviewCycle.questions.teamSkills
                                                            .roleReviewee,
                                                    'fa-circle': !reviewCycle.questions.teamSkills
                                                        .roleReviewee,
                                                }"
                                            >
                                            </i>
                                            <span class="l-default-margin-s">{{
                                                $t(`reviews.admin.labelRoleReviewee`)
                                            }}</span>
                                        </button>
                                        <button
                                            v-show="reviewCycle.managerReviewsEnabled"
                                            v-b-popover.hover.top="
                                                $t(`reviews.admin.helpRoleManager`)
                                            "
                                            class="btn-invisible color-primary"
                                            @click="questionToggleRole('teamSkills', 'roleManager')"
                                        >
                                            <i
                                                class="fal color-primary"
                                                :class="{
                                                    'fa-check-circle':
                                                        reviewCycle.questions.teamSkills
                                                            .roleManager,
                                                    'fa-circle': !reviewCycle.questions.teamSkills
                                                        .roleManager,
                                                }"
                                            >
                                            </i>
                                            <span class="l-default-margin-s">{{
                                                $t(`reviews.admin.labelRoleManager`)
                                            }}</span>
                                        </button>
                                        <button
                                            v-show="reviewCycle.peerReviewsEnabled"
                                            v-b-popover.hover.top="$t(`reviews.admin.helpRolePeer`)"
                                            class="btn-invisible color-primary"
                                            @click="questionToggleRole('teamSkills', 'rolePeer')"
                                        >
                                            <i
                                                class="fal color-primary"
                                                :class="{
                                                    'fa-check-circle':
                                                        reviewCycle.questions.teamSkills.rolePeer,
                                                    'fa-circle': !reviewCycle.questions.teamSkills
                                                        .rolePeer,
                                                }"
                                            >
                                            </i>
                                            <span class="l-default-margin-s">{{
                                                $t(`reviews.admin.labelRolePeer`)
                                            }}</span>
                                        </button>
                                        <button
                                            v-show="reviewCycle.directReportReviewsEnabled"
                                            v-b-popover.hover.top="
                                                $t(`reviews.admin.helpRoleDirectReport`)
                                            "
                                            class="btn-invisible color-primary"
                                            @click="
                                                questionToggleRole('teamSkills', 'roleDirectReport')
                                            "
                                        >
                                            <i
                                                class="fal color-primary"
                                                :class="{
                                                    'fa-check-circle':
                                                        reviewCycle.questions.teamSkills
                                                            .roleDirectReport,
                                                    'fa-circle': !reviewCycle.questions.teamSkills
                                                        .roleDirectReport,
                                                }"
                                            >
                                            </i>
                                            <span class="l-default-margin-s">{{
                                                $t(`reviews.admin.labelRoleDirectReport`)
                                            }}</span>
                                        </button>
                                    </div>

                                    <div
                                        :class="{
                                            'col-md-2': reviewCycle.questions.customScoresEnabled,
                                            'col-md-3': !reviewCycle.questions.customScoresEnabled,
                                        }"
                                    >
                                        <div style="margin-top: 0px">
                                            <l-select
                                                v-model="
                                                    reviewCycle.questions.teamSkills
                                                        .ratingRequirement
                                                "
                                                :options="optionsRatingRequirement"
                                                :disabled="
                                                    reviewCycle.isCreatedFromTemplate &&
                                                        reviewCycle.createdAsRole != 'admin'
                                                "
                                            />
                                        </div>
                                    </div>

                                    <div
                                        v-show="
                                            reviewCycle.questions.customScoresEnabled &&
                                                reviewCycle.questions.teamSkills
                                                    .ratingRequirement != 'hidden'
                                        "
                                        class="col-md-1"
                                    >
                                        <div style="margin-top: 0px">
                                            <l-input-text
                                                v-model="reviewCycle.questions.teamSkills.weight"
                                                :placeholder="$t(`reviews.admin.labelWeight`)"
                                                :disabled="reviewCycle.questionsLocked"
                                            />
                                        </div>
                                    </div>

                                    <div class="col-md-3">
                                        <div style="margin-top: 0px">
                                            <l-select
                                                v-model="
                                                    reviewCycle.questions.teamSkills
                                                        .commentRequirement
                                                "
                                                :options="optionsCommentRequirement"
                                                :disabled="
                                                    reviewCycle.isCreatedFromTemplate &&
                                                        reviewCycle.createdAsRole != 'admin'
                                                "
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div v-show="currentUser.rights.A_FEAT" class="color-grey">
                                    <div class="hr-small"></div>
                                    <span v-html="$t(`reviews.admin.labelHelpSkills`)"></span>
                                    <span
                                        v-show="!reviewCycle.questionsLocked"
                                        class="pull-right clickable"
                                        tabindex="0"
                                        @click="
                                            indexQuestions(
                                                reviewCycle.questions.companySkills.manual,
                                                true,
                                            )
                                        "
                                        @keyup.enter="
                                            indexQuestions(
                                                reviewCycle.questions.companySkills.manual,
                                                true,
                                            )
                                        "
                                    >
                                        <i class="fal fa-cog"></i>
                                        <span class="l-default-margin-s">{{
                                            $t(`reviews.admin.btnPickManually`)
                                        }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- Goals -->

                        <div
                            v-show="
                                currentUser.rights.G_VIEW &&
                                    question.type == 'reviewGoalPlaceholder'
                            "
                            class="card card-light"
                        >
                            <div
                                class="card-header"
                                :class="{
                                    'card-header-semi-rounded': reviewCycle.questions.goals.enabled,
                                    'card-header-rounded': !reviewCycle.questions.goals.enabled,
                                }"
                            >
                                <div class="row">
                                    <div
                                        v-show="!reviewCycle.questionsLocked"
                                        class="col-md-12 clickable"
                                        tabindex="0"
                                        @click="toggleGoals"
                                        @keyup.enter="toggleGoals"
                                    >
                                        <span>
                                            <i
                                                class="fal"
                                                :class="{
                                                    'fa-check-circle color-primary':
                                                        reviewCycle.questions.goals.enabled,
                                                    'fa-circle': !reviewCycle.questions.goals
                                                        .enabled,
                                                }"
                                            >
                                            </i>
                                            <span
                                                v-show="reviewCycle.questions.goals.enabled"
                                                class="l-default-margin-s"
                                                ><l-text :text="$t(`reviews.admin.includeGoals`)"
                                            /></span>
                                            <span
                                                v-show="!reviewCycle.questions.goals.enabled"
                                                class="l-default-margin-s"
                                                ><l-text
                                                    :text="$t(`reviews.admin.includeGoalsSelect`)"
                                            /></span>
                                        </span>
                                    </div>
                                    <div v-show="reviewCycle.questionsLocked" class="col-md-12">
                                        <span>
                                            <i
                                                class="fal"
                                                :class="{
                                                    'fa-check-circle color-primary':
                                                        reviewCycle.questions.goals.enabled,
                                                    'fa-circle': !reviewCycle.questions.goals
                                                        .enabled,
                                                }"
                                            >
                                            </i>
                                            <span
                                                v-show="reviewCycle.questions.goals.enabled"
                                                class="l-default-margin-s"
                                                ><l-text :text="$t(`reviews.admin.includeGoals`)"
                                            /></span>
                                            <span
                                                v-show="!reviewCycle.questions.goals.enabled"
                                                class="l-default-margin-s"
                                                ><l-text
                                                    :text="$t(`reviews.admin.includeGoalsSelect`)"
                                            /></span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div v-show="reviewCycle.questions.goals.enabled" class="card-block">
                                <div class="row">
                                    <div class="col-md-6" style="margin-top: 10px">
                                        <button
                                            v-show="reviewCycle.selfEvaluationsEnabled"
                                            v-b-popover.hover.top="
                                                $t(`reviews.admin.helpRoleReviewee`)
                                            "
                                            class="btn-invisible color-primary"
                                            @click="questionToggleRole('goals', 'roleReviewee')"
                                        >
                                            <i
                                                class="fal"
                                                :class="{
                                                    'fa-check-circle color-primary':
                                                        reviewCycle.questions.goals.roleReviewee,
                                                    'fa-circle': !reviewCycle.questions.goals
                                                        .roleReviewee,
                                                }"
                                            >
                                            </i>
                                            <span class="l-default-margin-s">{{
                                                $t(`reviews.admin.labelRoleReviewee`)
                                            }}</span>
                                        </button>
                                        <button
                                            v-show="reviewCycle.managerReviewsEnabled"
                                            v-b-popover.hover.top="
                                                $t(`reviews.admin.helpRoleManager`)
                                            "
                                            class="btn-invisible color-primary"
                                            @click="questionToggleRole('goals', 'roleManager')"
                                        >
                                            <i
                                                class="fal"
                                                :class="{
                                                    'fa-check-circle color-primary':
                                                        reviewCycle.questions.goals.roleManager,
                                                    'fa-circle': !reviewCycle.questions.goals
                                                        .roleManager,
                                                }"
                                            >
                                            </i>
                                            <span class="l-default-margin-s">{{
                                                $t(`reviews.admin.labelRoleManager`)
                                            }}</span>
                                        </button>
                                        <button
                                            v-show="reviewCycle.peerReviewsEnabled"
                                            v-b-popover.hover.top="$t(`reviews.admin.helpRolePeer`)"
                                            class="btn-invisible color-primary"
                                            @click="questionToggleRole('goals', 'rolePeer')"
                                        >
                                            <i
                                                class="fal"
                                                :class="{
                                                    'fa-check-circle color-primary':
                                                        reviewCycle.questions.goals.rolePeer,
                                                    'fa-circle': !reviewCycle.questions.goals
                                                        .rolePeer,
                                                }"
                                            >
                                            </i>
                                            <span class="l-default-margin-s">{{
                                                $t(`reviews.admin.labelRolePeer`)
                                            }}</span>
                                        </button>
                                        <button
                                            v-show="reviewCycle.directReportReviewsEnabled"
                                            v-b-popover.hover.top="
                                                $t(`reviews.admin.helpRoleDirectReport`)
                                            "
                                            class="btn-invisible color-primary"
                                            @click="questionToggleRole('goals', 'roleDirectReport')"
                                        >
                                            <i
                                                class="fal"
                                                :class="{
                                                    'fa-check-circle color-primary':
                                                        reviewCycle.questions.goals
                                                            .roleDirectReport,
                                                    'fa-circle': !reviewCycle.questions.goals
                                                        .roleDirectReport,
                                                }"
                                            >
                                            </i>
                                            <span class="l-default-margin-s">{{
                                                $t(`reviews.admin.labelRoleDirectReport`)
                                            }}</span>
                                        </button>
                                    </div>

                                    <div
                                        :class="{
                                            'col-md-2': reviewCycle.questions.customScoresEnabled,
                                            'col-md-3': !reviewCycle.questions.customScoresEnabled,
                                        }"
                                    >
                                        <div style="margin-top: 0px">
                                            <l-select
                                                v-model="
                                                    reviewCycle.questions.goals.ratingRequirement
                                                "
                                                :options="optionsRatingRequirement"
                                                :disabled="
                                                    reviewCycle.isCreatedFromTemplate &&
                                                        reviewCycle.createdAsRole != 'admin'
                                                "
                                            />
                                        </div>
                                    </div>

                                    <div
                                        v-show="
                                            reviewCycle.questions.customScoresEnabled &&
                                                reviewCycle.questions.goals.ratingRequirement !=
                                                    'hidden'
                                        "
                                        class="col-md-1"
                                    >
                                        <div style="margin-top: 0px">
                                            <l-input-text
                                                v-model="reviewCycle.questions.goals.weight"
                                                :placeholder="$t(`reviews.admin.labelWeight`)"
                                                :disabled="reviewCycle.questionsLocked"
                                            />
                                        </div>
                                    </div>

                                    <div class="col-md-3">
                                        <div style="margin-top: 0px">
                                            <l-select
                                                v-model="
                                                    reviewCycle.questions.goals.commentRequirement
                                                "
                                                :options="optionsCommentRequirement"
                                                :disabled="
                                                    reviewCycle.isCreatedFromTemplate &&
                                                        reviewCycle.createdAsRole != 'admin'
                                                "
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div v-show="currentUser.rights.A_FEAT" class="color-grey">
                                    <div class="hr-small"></div>
                                    <button class="btn-invisible color-primary" disabled>
                                        <i class="fal fa-check-circle color-primary"> </i>
                                        <span class="l-default-margin-s">{{
                                            $t(`reviews.admin.includeGoalsPersonal`)
                                        }}</span>
                                    </button>
                                    <button
                                        class="btn-invisible color-primary"
                                        @click="toggleGoalsIncludeContributors()"
                                    >
                                        <i
                                            class="fal color-primary"
                                            :class="
                                                reviewCycle.questions.goals.includeContributors
                                                    ? 'fa-check-circle'
                                                    : 'fa-circle'
                                            "
                                        >
                                        </i>
                                        <span class="l-default-margin-s">{{
                                            $t(`reviews.admin.includeGoalsContributor`)
                                        }}</span>
                                    </button>
                                    <div class="hr-small"></div>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <l-input-typeahead
                                                :label="``"
                                                :placeholder="$t(`reviews.admin.labelGoalTags`)"
                                                :show-picture="false"
                                                :data="tags"
                                                :on-select="goalsAddTag"
                                                :on-input-change="typeaheadTagsOnInputChange"
                                            />
                                        </div>
                                    </div>
                                    <div
                                        v-if="
                                            reviewCycle.questions &&
                                                reviewCycle.questions.goals &&
                                                reviewCycle.questions.goals.tags &&
                                                reviewCycle.questions.goals.tags.length
                                        "
                                        style="margin-bottom: 20px"
                                    >
                                        <span
                                            v-for="(tag, index) in reviewCycle.questions.goals.tags"
                                            :key="tag._id"
                                        >
                                            <span
                                                class="label label-primary r-default-margin-s clickable"
                                                tabindex="0"
                                                @click="goalsRemoveTag(index)"
                                                @keyup.enter="goalsRemoveTag(index)"
                                            >
                                                {{ tag.name
                                                }}<i class="fal fa-times l-default-margin-s"></i>
                                            </span>
                                        </span>
                                    </div>
                                    <div
                                        v-show="
                                            !isTemplate &&
                                                reviewCycle.status.globalStatus != 'draft'
                                        "
                                    >
                                        <div class="hr-small" />
                                        <button
                                            class="btn-invisible color-primary"
                                            tabindex="0"
                                            @click="updateGoals()"
                                            @keyup.enter="updateGoals()"
                                        >
                                            <i v-show="!updatingGoals" class="fal fa-check"></i>
                                            <i
                                                v-show="updatingGoals"
                                                class="fal fa-repeat fa-spin"
                                            ></i>
                                            <span class="l-default-margin-s">{{
                                                $t(`reviews.admin.labelUpdateGoals`)
                                            }}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </transition-group>
            </draggable>

            <div class="text-center" style="margin-bottom: 20px">
                <button
                    v-show="!reviewCycle.questionsLocked"
                    class="btn btn-primary btn-framed btn-framed-primary"
                    @click="addQuestion()"
                >
                    <i class="fal fa-plus"></i>
                    <span class="l-default-margin-s">{{ $t(`reviews.admin.btnAddQuestion`) }}</span>
                </button>

                <button
                    v-show="!reviewCycle.questionsLocked"
                    class="btn btn-primary btn-framed btn-framed-primary"
                    @click="addSection()"
                >
                    <i class="fal fa-plus"></i>
                    <span class="l-default-margin-s">{{ $t(`reviews.admin.btnAddSection`) }}</span>
                </button>
            </div>

            <!-- SCALE SETTINGS -->

            <div v-show="!reviewCycle.questionsLocked">
                <div class="hr-small"></div>
                <h4
                    class="reviewSetupHeading fake-link clickable"
                    tabindex="0"
                    @click="showScale = !showScale"
                    @keyup.enter="showScale = !showScale"
                >
                    <strong>{{
                        $t(`reviews.admin.labelShowScale`, { type: reviewCycle.scale.type })
                    }}</strong>
                </h4>
                <div v-show="showScale">
                    <div class="row">
                        <div class="col-md-2">
                            <l-select
                                :value="reviewCycle.scale.type"
                                :label="$t(`reviews.admin.labelScaleType`)"
                                :options="optionsScaleType"
                                @input="
                                    val => {
                                        reviewCycle.scale.type = val;
                                        updateScale(reviewCycle, val);
                                    }
                                "
                            />
                        </div>
                        <div class="col-md-10">
                            <div
                                v-for="item in ['1st', '2nd', '3rd', '4th', '5th', '6th', '7th']"
                                :key="item"
                            >
                                <l-input-text
                                    v-if="
                                        reviewCycle.scale.type != '100' &&
                                            reviewCycle.scale.type >= item.charAt(0)
                                    "
                                    v-model="reviewCycle.scale[`r${item.charAt(0)}`].label"
                                    :label="$t(`reviews.admin.label${item}`)"
                                />
                            </div>

                            <!-- start continues scale -->
                            <template v-if="reviewCycle.scale.type === '100'">
                                <l-input-text
                                    v-model="reviewCycle.scale.r1.label"
                                    :label="$t(`reviews.admin.labelLowerEnd`)"
                                />
                                <l-input-text
                                    v-model="reviewCycle.scale.r5.label"
                                    :label="$t(`reviews.admin.labelUpperEnd`)"
                                />
                            </template>
                            <!-- end continues scale -->
                        </div>
                    </div>
                    <div v-show="reviewCycle.scale.type !== '100'">
                        <div class="hr-small"></div>
                        <label class="color-dark">
                            <input
                                v-model="reviewCycle.scale.hideNumbers"
                                type="checkbox"
                                :disabled="reviewCycle.questionSettingsLocked"
                            />
                            <span class="l-default-margin-s">{{
                                $t(`reviews.admin.labelScaleHideNumbers`)
                            }}</span>
                        </label>
                    </div>
                    <div class="hr-small"></div>
                    <label class="color-dark">
                        <input
                            v-model="reviewCycle.questions.customScoresEnabled"
                            type="checkbox"
                            :disabled="reviewCycle.questionsLocked"
                        />
                        <span class="l-default-margin-s">{{
                            $t(`reviews.admin.labelCustomScoresEnabled`)
                        }}</span>
                        <i
                            v-b-popover.hover.top="$t(`reviews.admin.helpCustomScoresEnabled`)"
                            class="fal fa-question-circle l-default-margin"
                        ></i>
                    </label>
                </div>
            </div>

            <div class="hr-small"></div>

            <div>
                <h4 class="reviewSetupHeading color-dark">
                    <strong>{{ $t(`reviews.admin.labelPreview`) }}</strong>
                </h4>

                <div class="row">
                    <div v-show="reviewCycle.createdAsRole !== 'employee'" class="col-md-5">
                        <l-input-typeahead
                            :label="``"
                            :placeholder="$t(`reviews.admin.labelPreviewUser`)"
                            :data="users"
                            :on-select="changePreviewUser"
                            :on-input-change="typeaheadOnInputChange"
                            display-selected-value
                        />
                    </div>
                    <div
                        :class="reviewCycle.createdAsRole !== 'employee' ? 'col-md-4' : 'col-md-5'"
                    >
                        <l-select
                            v-model="previewRole"
                            style="margin-top: 10px;"
                            :options="optionsPreviewRole"
                        />
                    </div>
                    <div class="col-md-3">
                        <button
                            class="btn btn-default btn-block"
                            :disabled="!previewUser._id"
                            :class="{ 'btn-raised': previewUser._id }"
                            @click="previewQuestionnaire()"
                        >
                            {{ $t(`reviews.admin.btnPreview`) }}
                        </button>
                    </div>
                </div>
            </div>

            <div
                v-show="
                    currentUser.rights.A_FEAT &&
                        !isTemplate &&
                        reviewCycle.status.globalStatus != 'draft'
                "
            >
                <div class="hr-small"></div>
                <div
                    class="color-primary clickable"
                    tabindex="0"
                    @click="updateSkillAssignment()"
                    @keyup.enter="updateSkillAssignment()"
                >
                    <i v-show="!isUpdatingSkillAssignment" class="fal fa-cog"></i>
                    <i v-show="isUpdatingSkillAssignment" class="fal fa-cog fa-spin"></i>
                    &nbsp;
                    <span
                        v-b-popover.hover.top="$t(`reviews.admin.labelChangesAffectActiveCycle`)"
                        class="l-default-margin-s"
                    >
                        {{ $t(`reviews.admin.labelUpdateSkillAssignment`) }}</span
                    >
                </div>
            </div>
        </div>

        <hr />

        <div v-if="error" id="error" class="alert alert-danger">
            <span>{{ error.message }}</span>
        </div>

        <div class="row">
            <div class="col-md-4 col-md-offset-8">
                <button class="btn btn-block btn-primary btn-raised" type="button" @click="next()">
                    {{ $t(`reviews.admin.btnContinue`) }}
                </button>
            </div>
        </div>

        <!-- PREVIEW -->
        <l-modal v-show="showModal" size="l" close-on-backdrop-click @close="goBack">
            <template #header>{{ $t(`reviews.admin.labelPreviewQuestionnaire`) }}</template>
            <template #body>
                <router-view></router-view>
            </template>
        </l-modal>
        <!--/PREVIEW -->
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import debounce from "lodash.debounce";

import format from "@/utils/format-typeahead";
import generateDefaultId from "@/utils/generate-default-id";
import getVal from "@/utils/get-nested-object-lookup";

import Draggable from "vuedraggable";

import LInputText from "@/components/LInputText";
import LInputTypeahead from "@/components/LInputTypeahead";
import LModal from "@/components/LModal";
import LSelect from "@/components/LSelect";
import LSpace from "@/components/LSpace";
import LText from "@/components/LText";
import LTranslationModal from "@/components/LTranslationModal";

export default {
    components: {
        Draggable,

        LInputText,
        LInputTypeahead,
        LModal,
        LSelect,
        LSpace,
        LText,
        LTranslationModal,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        isTemplate: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            reviewCycle: {
                questions: {
                    selected: [],
                    skills: [],
                    settings: {},
                    companySkills: null,
                    teamSkills: null,
                    goals: null,
                },
            },
            error: null,
            showModal: false,

            previewRole: "manager",
            areQuestionsExpanded: false,
            isUpdatingSkillAssignment: false,
            questionIndex: [],
            updatingGoals: false,
            showScale: false,
            previewUser: {},

            showTranslationModal: false,
            translations: {},
            inputType: "",
        };
    },
    computed: {
        ...mapGetters({
            currentUser: "users/current/user",
            locale: "users/current/locale",
            getTemplateDetails: "reviews/templates/details",
            getCycleDetails: "reviews/cycles/details",

            usersSearchList: "users/search/list",
            tagsSearchList: "tags/search/list",
            getSkills: "skills/getSkills",
        }),

        skills() {
            return this.getSkills();
        },

        users() {
            return this.usersSearchList.map(format.users);
        },

        tags() {
            return this.tagsSearchList.map(tag => ({
                _id: tag._id,
                name: tag.name,
                desc: "",
            }));
        },

        optionsScaleType() {
            return [
                { value: "2", text: this.$t(`reviews.admin.label2point`) },
                { value: "3", text: this.$t(`reviews.admin.label3point`) },
                { value: "4", text: this.$t(`reviews.admin.label4point`) },
                { value: "5", text: this.$t(`reviews.admin.label5point`) },
                { value: "6", text: this.$t(`reviews.admin.label6point`) },
                { value: "7", text: this.$t(`reviews.admin.label7point`) },
                { value: "100", text: this.$t(`reviews.admin.labelContinuousScale`) },
            ];
        },

        optionsPreviewRole() {
            const options = [];

            if (this.reviewCycle.selfEvaluationsEnabled) {
                options.push({
                    value: "reviewee",
                    text: this.$t(`reviews.admin.optionQFilterReviewee`),
                });
            }
            if (this.reviewCycle.managerReviewsEnabled) {
                options.push({
                    value: "manager",
                    text: this.$t(`reviews.admin.optionQFilterManager`),
                });
            }
            if (this.reviewCycle.peerReviewsEnabled) {
                options.push({ value: "peer", text: this.$t(`reviews.admin.optionQFilterPeer`) });
            }
            if (this.reviewCycle.directReportReviewsEnabled) {
                options.push({
                    value: "directReport",
                    text: this.$t(`reviews.admin.optionQFilterDirectReport`),
                });
            }

            return options;
        },

        optionsRatingRequirement() {
            return [
                { value: "required", text: this.$t(`reviews.admin.optionRatingRequired`) },
                { value: "optional", text: this.$t(`reviews.admin.optionRatingOptional`) },
                { value: "hidden", text: this.$t(`reviews.admin.optionRatingHidden`) },
            ];
        },

        optionsCommentRequirement() {
            return [
                { value: "required", text: this.$t(`reviews.admin.optionCommentRequired`) },
                { value: "optional", text: this.$t(`reviews.admin.optionCommentOptional`) },
                { value: "hidden", text: this.$t(`reviews.admin.optionCommentHidden`) },
            ];
        },
    },
    watch: {
        $route: {
            immediate: true,
            handler(newRoute) {
                this.reviewCycle = this.isTemplate
                    ? this.getTemplateDetails(this.id)
                    : this.getCycleDetails(this.id);

                this.indexQuestions();

                this.showModal = newRoute.meta && newRoute.meta.modal;
            },
        },
        reviewCycle: {
            deep: true,
            handler: debounce(function handler() {
                this.update();
            }, 1000),
        },
    },
    methods: {
        toggleCompanySkills() {
            this.$set(
                this.reviewCycle.questions.companySkills,
                "enabled",
                !this.reviewCycle.questions.companySkills.enabled,
            );
        },

        toggleTeamSkills() {
            this.$set(
                this.reviewCycle.questions.teamSkills,
                "enabled",
                !this.reviewCycle.questions.teamSkills.enabled,
            );
        },

        toggleGoals() {
            this.$set(
                this.reviewCycle.questions.goals,
                "enabled",
                !this.reviewCycle.questions.goals.enabled,
            );
        },

        questionToggleExpansion(index, toggleAll) {
            if (toggleAll) {
                this.reviewCycle.questions.selected.forEach(question => {
                    this.$set(question, "expanded", !this.areQuestionsExpanded);
                });

                this.areQuestionsExpanded = !this.areQuestionsExpanded;

                return;
            }

            this.$set(
                this.reviewCycle.questions.selected[index],
                "expanded",
                !this.reviewCycle.questions.selected[index].expanded,
            );
        },

        removeQuestion(index) {
            this.reviewCycle.questions.selected.splice(index, 1);
        },

        questionToggleRole(question, role) {
            if (this.reviewCycle.questionSettingsLocked) {
                return;
            }

            if (role == "roleReviewee" && !this.reviewCycle.selfEvaluationsEnabled) {
                return;
            }

            if (role == "roleManager" && !this.reviewCycle.managerReviewsEnabled) {
                return;
            }

            if (role == "rolePeer" && !this.reviewCycle.peerReviewsEnabled) {
                return;
            }

            if (role == "roleDirectReport" && !this.reviewCycle.directReportReviewsEnabled) {
                return;
            }

            if (question == "companySkills" || question == "teamSkills" || question == "goals") {
                if (this.reviewCycle.questions[question][role]) {
                    this.reviewCycle.questions[question][role] = false;
                } else {
                    this.reviewCycle.questions[question][role] = true;
                }
            } else {
                for (var j = 0; j < this.reviewCycle.questions.selected.length; j++) {
                    if (
                        this.reviewCycle.questions.selected[j]._id == question._id &&
                        this.reviewCycle.questions.selected[j].name == question.name
                    ) {
                        if (
                            question.private &&
                            role == "roleReviewee" &&
                            !this.reviewCycle.questions.selected[j][role]
                        ) {
                            continue;
                        } else if (question[role]) {
                            this.reviewCycle.questions.selected[j][role] = false;
                        } else {
                            this.reviewCycle.questions.selected[j][role] = true;
                        }
                    }
                }
            }
        },

        questionTogglePrivate(index) {
            if (this.reviewCycle.questionSettingsLocked) {
                return;
            }

            this.reviewCycle.questions.selected[index].private = !this.reviewCycle.questions
                .selected[index].private;

            // disable reviewee role

            this.reviewCycle.questions.selected[index].roleReviewee = false;
        },

        questionToggleMultipleChoice(index) {
            if (this.reviewCycle.questionsLocked) {
                return;
            }

            if (this.reviewCycle.questions.selected[index].answerType == "multipleChoice") {
                this.reviewCycle.questions.selected[index].answerType = undefined;
                this.reviewCycle.questions.selected[index].commentRequirement = "optional";
                this.reviewCycle.questions.selected[index].ratingRequirement = "hidden";
            } else {
                this.reviewCycle.questions.selected[index].answerType = "multipleChoice";
                this.reviewCycle.questions.selected[index].commentRequirement = "hidden";
                this.reviewCycle.questions.selected[index].ratingRequirement = "hidden";
                this.reviewCycle.questions.selected[index].allowMultipleAnswers = false;
                this.$set(this.reviewCycle.questions.selected[index], "multipleChoiceOptions", [
                    {
                        title: "",
                    },
                    {
                        title: "",
                    },
                    {
                        title: "",
                    },
                ]);
            }
        },

        questionToggleAllowMultipleAnswers(index) {
            if (this.reviewCycle.questionsLocked) {
                return;
            }

            if (this.reviewCycle.questions.selected[index].allowMultipleAnswers) {
                this.reviewCycle.questions.selected[index].allowMultipleAnswers = false;
            } else {
                this.reviewCycle.questions.selected[index].allowMultipleAnswers = true;
            }
        },

        toggleCustomScale(question) {
            if (!question || !this.reviewCycle.scale) {
                return;
            }
            if (!question.scale) {
                this.$set(question, "scale", {});
                question.scale = {
                    enabled: true,
                    type: this.reviewCycle.scale.type,
                };
                this.updateScale(question, this.reviewCycle.scale.type);
                return;
            }
            if (question.scale.enabled == false) {
                question.scale.enabled = true;
                return;
            }
            if (question.scale.enabled) {
                question.scale.enabled = false;
                return;
            }
        },

        toggleGoalsIncludeContributors() {
            this.$set(
                this.reviewCycle.questions.goals,
                "includeContributors",
                !this.reviewCycle.questions.goals.includeContributors,
            );
        },

        addMultipleChoiceOption(index) {
            if (this.reviewCycle.questionsLocked) {
                return;
            }

            this.reviewCycle.questions.selected[index].multipleChoiceOptions.push({
                title: "",
            });
        },
        removeMultipleChoiceOption(index, mcIndex) {
            if (this.reviewCycle.questionsLocked) {
                return;
            }

            // Can't delete the last option
            if (this.reviewCycle.questions.selected[index].multipleChoiceOptions.length <= 1) {
                return;
            }

            if (
                mcIndex < 0 ||
                mcIndex >= this.reviewCycle.questions.selected[index].multipleChoiceOptions.length
            ) {
                return;
            }

            Object.keys(this.reviewCycle.questions.selected[index].translations).forEach(locale => {
                if (
                    this.reviewCycle.questions.selected[index].translations[locale]
                        .multipleChoiceOptions?.[mcIndex]
                ) {
                    for (
                        let i = mcIndex + 1;
                        i < this.reviewCycle.questions.selected[index].multipleChoiceOptions.length;
                        i++
                    ) {
                        if (
                            this.reviewCycle.questions.selected[index].translations[locale]
                                .multipleChoiceOptions[i]
                        ) {
                            this.reviewCycle.questions.selected[index].translations[
                                locale
                            ].multipleChoiceOptions[i - 1] = this.reviewCycle.questions.selected[
                                index
                            ].translations[locale].multipleChoiceOptions[i];
                        }
                    }

                    delete this.reviewCycle.questions.selected[index].translations[locale]
                        .multipleChoiceOptions[
                        this.reviewCycle.questions.selected[index].multipleChoiceOptions.length - 1
                    ];
                }
            });

            this.reviewCycle.questions.selected[index].multipleChoiceOptions.splice(mcIndex, 1);
        },

        updateScale(questionOrReviewCycle, type) {
            // clear

            questionOrReviewCycle.scale = {
                enabled: true,
            };

            // apply new scale

            if (type == "2")
                questionOrReviewCycle.scale = {
                    ...questionOrReviewCycle.scale,
                    type: "2",
                    r1: { label: "Development Area", amount: 0 },
                    r2: { label: "Strength", amount: 100 },
                    r3: { amount: 999 },
                    r4: { amount: 999 },
                    r5: { amount: 999 },
                };
            else if (type == "3")
                questionOrReviewCycle.scale = {
                    ...questionOrReviewCycle.scale,
                    type: "3",
                    r1: { label: "Below expectations", amount: 0 },
                    r2: { label: "Meeting expectations", amount: 50 },
                    r3: { label: "Above expectations", amount: 100 },
                    r4: { amount: 999 },
                    r5: { amount: 999 },
                };
            else if (type == "4")
                questionOrReviewCycle.scale = {
                    ...questionOrReviewCycle.scale,
                    type: "4",
                    r1: { label: "Basic", amount: 0 },
                    r2: { label: "Good", amount: 33 },
                    r3: { label: "Strong", amount: 66 },
                    r4: { label: "Expert", amount: 100 },
                    r5: { amount: 999 },
                };
            else if (type == "5")
                questionOrReviewCycle.scale = {
                    ...questionOrReviewCycle.scale,
                    type: "5",
                    r1: { label: "Needs strong improvement", amount: 0 },
                    r2: { label: "Needs improvement", amount: 25 },
                    r3: { label: "Consistently meets expectations", amount: 50 },
                    r4: { label: "Exceeds expectations", amount: 75 },
                    r5: { label: "Superb", amount: 100 },
                };
            else if (type == "6")
                questionOrReviewCycle.scale = {
                    ...questionOrReviewCycle.scale,
                    type: "6",
                    r1: { label: "Poor", amount: 0 },
                    r2: { label: "Fair", amount: 20 },
                    r3: { label: "Good", amount: 40 },
                    r4: { label: "Very good", amount: 60 },
                    r5: { label: "Excellent", amount: 80 },
                    r6: { label: "Exceptional", amount: 100 },
                };
            else if (type == "7")
                questionOrReviewCycle.scale = {
                    ...questionOrReviewCycle.scale,
                    type: "7",
                    r1: { label: "Far below", amount: 0 },
                    r2: { label: "Moderately below", amount: 16 },
                    r3: { label: "Slightly below", amount: 33 },
                    r4: { label: "Met expectations ", amount: 50 },
                    r5: { label: "Slightly above", amount: 67 },
                    r6: { label: "Moderately above", amount: 83 },
                    r7: { label: "Far above", amount: 100 },
                };
            else if (type == "100")
                questionOrReviewCycle.scale = {
                    ...questionOrReviewCycle.scale,
                    type: "100",
                    r1: { label: "Needs some improvement", amount: 0 },
                    r2: { label: "Tracking minus", amount: 25 },
                    r3: { label: "Tracking", amount: 50 },
                    r4: { label: "Tracking plus", amount: 75 },
                    r5: { label: "Clearly above expectations", amount: 100 },
                };

            this.update();
        },

        indexQuestions(setCompanySkillsManually, setTeamSkillsManually) {
            var questions = [];
            var questionIndex = [];

            // legacy adjustment

            if (!this.reviewCycle.questions.skills) {
                this.reviewCycle.questions.skills = [];
            }

            if (!this.reviewCycle.questions.settings) {
                this.reviewCycle.questions.settings = {};
            }

            // keep current custom questions

            var customQuestionnaireElements = [
                "review",
                "reviewSection",
                "reviewCompanySkillPlaceholder",
                "reviewTeamSkillPlaceholder",
                "reviewGoalPlaceholder",
            ];

            if (this.reviewCycle.questions.selected) {
                this.reviewCycle.questions.selected.forEach(question => {
                    if (customQuestionnaireElements.indexOf(question.type) > -1) {
                        questions.push(question);
                    }

                    if (customQuestionnaireElements.indexOf(question.type) > -1 && question._id) {
                        questionIndex.push(question._id);
                    }
                });
            }

            // set company, team, goal defaults

            if (!this.reviewCycle.questions.companySkills) {
                this.$set(this.reviewCycle.questions, "companySkills", {
                    enabled: true,
                    manual: false,
                    ratingRequirement: "required",
                    commentRequirement: "optional",
                    roleReviewee: true,
                    roleManager: true,
                    rolePeer: true,
                    roleDirectReport: true,
                });
            }
            if (!this.reviewCycle.questions.teamSkills) {
                this.$set(this.reviewCycle.questions, "teamSkills", {
                    enabled: false,
                    ratingRequirement: "required",
                    commentRequirement: "optional",
                    roleReviewee: true,
                    roleManager: true,
                    rolePeer: true,
                    roleDirectReport: true,
                });
            }
            if (!this.reviewCycle.questions.goals) {
                this.$set(this.reviewCycle.questions, "goals", {
                    enabled: false,
                    ratingRequirement: "required",
                    commentRequirement: "optional",
                    roleReviewee: true,
                    roleManager: true,
                    rolePeer: false,
                    roleDirectReport: false,
                });
            }

            // set flags if company skills should be set manually

            if (setCompanySkillsManually || setTeamSkillsManually) {
                // add skills (at risk of duplication)

                this.reviewCycle.questions.skills = this.reviewCycle.questions.skills.concat(
                    this.skills,
                );
            }

            if (setCompanySkillsManually) {
                this.reviewCycle.questions.companySkills.manual = true;
                this.reviewCycle.questions.companySkills.enabled = false;
            } else if (typeof setCompanySkillsManually != "undefined") {
                this.reviewCycle.questions.companySkills.manual = false;
            }

            if (setTeamSkillsManually) {
                this.reviewCycle.questions.teamSkills.manual = true;
                this.reviewCycle.questions.teamSkills.enabled = false;
            } else if (typeof setTeamSkillsManually != "undefined") {
                this.reviewCycle.questions.teamSkills.manual = false;
            }

            this.reviewCycle.questions.skills.forEach(skill => {
                // skip duplicates

                if (skill._id && questionIndex.indexOf(skill._id) > -1) {
                    return;
                }

                // skip company / team skills

                if (skill.type == "team" && !this.reviewCycle.questions.companySkills.manual) {
                    // skip company skills if NOT MANUAL

                    return;
                }

                if (skill.type == "localTeam" && !this.reviewCycle.questions.teamSkills.manual) {
                    // skip team skills

                    return;
                }

                // adjustements for manually picked company skills

                if (!this.reviewCycle.questions.settings[skill._id]) {
                    this.reviewCycle.questions.settings[skill._id] = {
                        roles: ["reviewee", "manager", "peer", "directReport"],
                        commentRequirement: "optional",
                        ratingRequirement: "required",
                        private: false,
                    };
                }

                // create question

                var question = {
                    _id: skill._id,
                    name: skill.name,
                    description: skill.description,
                    type: skill.type, // should only be "review"?
                    answerType: skill.answerType,
                    multipleChoiceOptions: skill.multipleChoiceOptions,
                    allowMultipleAnswers: skill.allowMultipleAnswers,
                    roleReviewee:
                        this.reviewCycle.questions.settings[skill._id] &&
                        this.reviewCycle.questions.settings[skill._id].roles &&
                        this.reviewCycle.questions.settings[skill._id].roles.indexOf("reviewee") >
                            -1
                            ? true
                            : false,
                    roleManager:
                        this.reviewCycle.questions.settings[skill._id] &&
                        this.reviewCycle.questions.settings[skill._id].roles &&
                        this.reviewCycle.questions.settings[skill._id].roles.indexOf("manager") > -1
                            ? true
                            : false,
                    rolePeer:
                        this.reviewCycle.questions.settings[skill._id] &&
                        this.reviewCycle.questions.settings[skill._id].roles &&
                        this.reviewCycle.questions.settings[skill._id].roles.indexOf("peer") > -1
                            ? true
                            : false,
                    roleDirectReport:
                        this.reviewCycle.questions.settings[skill._id] &&
                        this.reviewCycle.questions.settings[skill._id].roles &&
                        this.reviewCycle.questions.settings[skill._id].roles.indexOf(
                            "directReport",
                        ) > -1
                            ? true
                            : false,
                    private: this.reviewCycle.questions.settings[skill._id]
                        ? this.reviewCycle.questions.settings[skill._id].private
                        : undefined,
                    commentRequirement: this.reviewCycle.questions.settings[skill._id]
                        ? this.reviewCycle.questions.settings[skill._id].commentRequirement
                        : undefined,
                    ratingRequirement: this.reviewCycle.questions.settings[skill._id]
                        ? this.reviewCycle.questions.settings[skill._id].ratingRequirement
                        : undefined,
                    weight: this.reviewCycle.questions.settings[skill._id]
                        ? this.reviewCycle.questions.settings[skill._id].weight
                        : undefined,
                    scale: this.reviewCycle.questions.settings[skill._id]
                        ? this.reviewCycle.questions.settings[skill._id].scale
                        : undefined,
                    translations: skill.translations,
                };

                // push to question array

                questions.push(question);

                // push to index to avoid duplicates

                questionIndex.push(question._id);
            });

            // placeholders

            if (
                !questions.some(function(q) {
                    return q.type == "reviewCompanySkillPlaceholder";
                })
            ) {
                questions.push({
                    name: "Placeholder Company Skills",
                    type: "reviewCompanySkillPlaceholder",
                });
            }

            if (
                !questions.some(function(q) {
                    return q.type == "reviewTeamSkillPlaceholder";
                })
            ) {
                questions.push({
                    name: "Placeholder Team Skills",
                    type: "reviewTeamSkillPlaceholder",
                });
            }

            if (
                !questions.some(function(q) {
                    return q.type == "reviewGoalPlaceholder";
                })
            ) {
                questions.push({
                    name: "Placeholder Goals",
                    type: "reviewGoalPlaceholder",
                });
            }

            this.$set(this.reviewCycle.questions, "selected", Array.from(questions));
            this.questionIndex = Array.from(questionIndex);

            if (setCompanySkillsManually) this.reviewCycle.questions.companySkills.enabled = false;
        },

        updateGoals() {
            this.updatingGoals = true;

            if (this.isTemplate) {
                this.$store
                    .dispatch({
                        type: "reviews/templates/update",
                        payload: { template: this.reviewCycle, scope: "goals" },
                    })
                    .then(() => {
                        setTimeout(() => {
                            this.updatingGoals = false;
                        }, 1000);
                    });
            } else {
                this.$store
                    .dispatch({
                        type: "reviews/cycles/update",
                        payload: { reviewCycle: this.reviewCycle, scope: "goals" },
                    })
                    .then(() => {
                        setTimeout(() => {
                            this.updatingGoals = false;
                        }, 1000);
                    });
            }
        },

        changePreviewUser(user) {
            this.previewUser = user;
        },
        typeaheadOnInputChange(query) {
            if (query.length >= 2) {
                this.$store.dispatch("users/search/findByName", { query, sort: "default" });
            } else {
                this.$store.dispatch("users/search/reset");
            }
        },

        goalsAddTag(tag) {
            if (!this.reviewCycle.questions.goals.tags) {
                this.reviewCycle.questions.goals.tags = [];
            }

            if (this.reviewCycle.questions.goals.tags.some(t => t._id === tag._id)) {
                return;
            }

            this.reviewCycle.questions.goals.tags.push(tag);
        },
        goalsRemoveTag(index) {
            this.reviewCycle.questions.goals.tags.splice(index, 1);
        },
        typeaheadTagsOnInputChange(query) {
            this.$store.dispatch("tags/search/findByName", { query });
        },

        addQuestion() {
            var newQuestion = {
                _id: undefined,
                tempId: generateDefaultId(),
                name: "",
                description: "",
                type: "review",
                roleReviewee: true,
                roleManager: true,
                rolePeer: true,
                roleDirectReport: true,
                commentRequirement: "required",
                ratingRequirement: "hidden",
                answerType: undefined,
                selected: true,
                private: false,
                expanded: true,
                allowMultipleAnswers: false,
                translations: {},
            };

            this.reviewCycle.questions.selected.push(newQuestion);
        },
        addSection() {
            var newSection = {
                _id: undefined,
                tempId: generateDefaultId(),
                name: "",
                description: "",
                type: "reviewSection",
                roleReviewee: true,
                roleManager: true,
                rolePeer: true,
                roleDirectReport: true,
                commentRequirement: "hidden",
                ratingRequirement: "hidden",
                selected: true,
                private: false,
                expanded: true,
            };

            this.reviewCycle.questions.selected.push(newSection);
        },

        openTranslationModal(skill, key, inputType) {
            this.currentSkill = skill;
            this.key = key;
            this.inputType = inputType;

            if (!this.currentSkill.translations) {
                this.currentSkill.translations = {};
            }

            this.translations = Object.keys(this.currentSkill.translations).reduce((acc, cur) => {
                acc[cur] = getVal(this.currentSkill.translations[cur], this.key);
                return acc;
            }, {});
            this.translations[this.locale] = getVal(this.currentSkill, this.key);

            if (!this.translations["en"]) {
                this.translations["en"] = "";
            }

            this.showTranslationModal = true;
        },

        updateSkillTranslation(skill, key) {
            if (!skill.translations) {
                skill.translations = { [this.locale]: {} };
            }

            if (key === "name") {
                skill.translations[this.locale].name = skill.name;
            } else if (key === "description") {
                skill.translations[this.locale].description = skill.description;
            } else if (key.startsWith("multipleChoiceOptions")) {
                if (!skill.translations[this.locale].multipleChoiceOptions) {
                    skill.translations[this.locale].multipleChoiceOptions = {};
                }
                if (!skill.translations[this.locale].multipleChoiceOptions[key.split(".")[1]]) {
                    skill.translations[this.locale].multipleChoiceOptions[key.split(".")[1]] = {};
                }

                skill.translations[this.locale].multipleChoiceOptions[key.split(".")[1]].title =
                    skill.multipleChoiceOptions[key.split(".")[1]].title;
            }

            this.update();
        },

        updateTranslations(translations) {
            // Add/Update current skill's translations
            Object.keys(translations).forEach(lang => {
                if (!this.currentSkill.translations[lang]) {
                    this.currentSkill.translations[lang] = {};
                }

                if (this.key === "name") {
                    this.currentSkill.translations[lang].name = translations[lang];
                } else if (this.key === "description") {
                    this.currentSkill.translations[lang].description = translations[lang];
                } else if (this.key.startsWith("multipleChoiceOptions")) {
                    if (!this.currentSkill.translations[lang].multipleChoiceOptions) {
                        this.currentSkill.translations[lang].multipleChoiceOptions = {};
                    }
                    if (
                        !this.currentSkill.translations[lang].multipleChoiceOptions[
                            this.key.split(".")[1]
                        ]
                    ) {
                        this.currentSkill.translations[lang].multipleChoiceOptions[
                            this.key.split(".")[1]
                        ] = {};
                    }

                    this.currentSkill.translations[lang].multipleChoiceOptions[
                        this.key.split(".")[1]
                    ].title = translations[lang];
                }
            });

            if (this.key === "name") {
                this.currentSkill.name = translations[this.locale];
            } else if (this.key.startsWith("multipleChoiceOptions")) {
                this.currentSkill.multipleChoiceOptions[this.key.split(".")[1]].title =
                    translations[this.locale];
            }

            // Delete translations
            Object.keys(this.currentSkill.translations).forEach(lang => {
                if (!translations[lang]) {
                    if (this.key === "name") {
                        delete this.currentSkill.translations[lang].name;
                    } else if (this.key.startsWith("multipleChoiceOptions")) {
                        delete this.currentSkill.translations[lang].multipleChoiceOptions[
                            this.key.split(".")[1]
                        ];
                    }

                    if (!Object.keys(this.currentSkill.translations[lang]).length) {
                        delete this.currentSkill.translations[lang];
                    }
                }
            });

            this.showTranslationModal = false;

            this.update();
        },

        previewQuestionnaire() {
            if (!this.previewRole || !this.previewUser?._id) {
                return;
            }

            if (this.isTemplate) {
                this.$router.push(
                    `/reviews/templates/edit/${this.id}/questions/preview/${this.previewRole}/${this.previewUser._id}`,
                );
            } else {
                this.$router.push(
                    `/reviews/cycles/edit/${this.id}/questions/preview/${this.previewRole}/${this.previewUser._id}`,
                );
            }
        },

        goBack() {
            if (this.isTemplate) {
                this.$router.push(`/reviews/templates/edit/${this.id}/questions`);
            } else {
                this.$router.push(`/reviews/cycles/edit/${this.id}/questions`);
            }
        },

        async updateSkillAssignment() {
            this.isUpdatingSkillAssignment = true;

            try {
                if (this.isTemplate) {
                    await this.$store.dispatch({
                        type: "reviews/templates/update",
                        payload: { template: this.reviewCycle, scope: "skillAssignment" },
                    });
                } else {
                    await this.$store.dispatch({
                        type: "reviews/cycles/update",
                        payload: { reviewCycle: this.reviewCycle, scope: "skillAssignment" },
                    });
                }
            } finally {
                setTimeout(() => {
                    this.isUpdatingSkillAssignment = false;
                }, 1000);
            }
        },

        async update() {
            this.error = null;

            try {
                if (this.isTemplate) {
                    await this.$store.dispatch({
                        type: "reviews/templates/update",
                        payload: { template: this.reviewCycle, scope: "questions" },
                    });
                } else {
                    await this.$store.dispatch({
                        type: "reviews/cycles/update",
                        payload: { reviewCycle: this.reviewCycle, scope: "questions" },
                    });
                }
            } catch (err) {
                if (err?.response?.data?.message) {
                    this.error = { message: err?.response?.data?.message };
                }
            }
        },

        async next() {
            await this.update();

            if (this.error === null) {
                this.$emit("next");
            }
        },
    },
};
</script>
